import { Popover, Typography, Box } from "@mui/material";
import Home from "../../assets/Images/Home.png";
import AppAIC1 from "../../assets/Images/app-aic-1.png";
import AppAIC2 from "../../assets/Images/app-aic-2.png";
import Global from "../../assets/Images/Global.png";
import AppStore from "../../assets/Images/appstore.png";
import GooglePlay from "../../assets/Images/googleplay.png";

interface IPopoverComponent {
  isOpen: boolean;
  anchorEl: HTMLButtonElement | null;
  handleClose: () => void;
}

const PopoverComponent = ({
  isOpen,
  anchorEl,
  handleClose,
}: IPopoverComponent) => {
  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          borderRadius: 4,
        },
      }}
    >
      <Box sx={{ p: 4, display: "flex", flexDirection: "column", gap: 4 }}>
        <Typography sx={{ color: "rgba(107, 115, 128, 1)" }} variant="body2">
          Explore more products from AICycle
        </Typography>
        <Box sx={{ display: "flex", gap: 4 }}>
          <img src={Home} alt="" width={106} height={86} />
          <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <Typography
              variant="caption"
              sx={{ color: "rgba(156, 163, 175, 1)" }}
            >
              Website
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              AICycle OCR
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                bgcolor: "rgba(244, 244, 246, 1)",
                paddingX: 3,
                paddingY: 1,
                borderRadius: 6,
              }}
            >
              <img src={Global} alt="" width={18} height={18} />
              <a
                href="https://ocr.aicycle.ai/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "rgba(47, 53, 60, 1)" }}
              >
                https://ocr.aicycle.ai/
              </a>
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 4 }}>
          <img src={AppAIC1} alt="" width={106} height={86} />
          <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <Typography
              variant="caption"
              sx={{ color: "rgba(156, 163, 175, 1)" }}
            >
              Application
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              AICycle Insurance
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <a
                href="https://apps.apple.com/vn/app/aicycle-insurance/id6449540256?l=vi"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={AppStore} alt="" width={109} height={32} />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.aicycle.insurance"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={GooglePlay} alt="" width={109} height={32} />
              </a>
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 4 }}>
          <img src={AppAIC2} alt="" width={106} height={86} />
          <Box sx={{ display: "flex", flexDirection: "column", gap: "5px" }}>
            <Typography
              variant="caption"
              sx={{ color: "rgba(156, 163, 175, 1)" }}
            >
              Application
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Video 360
            </Typography>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <a
                href="https://apps.apple.com/vn/app/video-360/id6446395952?l=vi"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={AppStore} alt="" width={109} height={32} />
              </a>
              <a
                href="https://play.google.com/store/apps/details?id=com.aicycle.insurance"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={GooglePlay} alt="" width={109} height={32} />
              </a>
            </Box>
          </Box>
        </Box>
      </Box>
    </Popover>
  );
};

export default PopoverComponent;
